import StarIcon from 'svgs/star.svg';

import * as styles from './index.module.scss';

const Stars = ({ theme = '' }) => (
  <div className={`${styles['stars-container']} ${theme ? styles[theme] : ''}`}>
    <StarIcon />
    <StarIcon />
    <StarIcon />
    <StarIcon />
    <StarIcon />
  </div>
);

export default Stars;
